export const AdditionalInfoPageContentEn = () => {
  return (
    <>
      <h2>Content</h2>
      <p>
        Information in the service is from European Environment Agency's (EEA){' '}
        <a
          href="https://www.eea.europa.eu/data-and-maps/data/industrial-reporting-under-the-industrial-3"
          target="blank">
          {' '}
          PRTR database
        </a>
        . The database includes information on PRTR facilities' releases to air
        and waste as well as waste transfers for the following activities:
      </p>
      <ul>
        <li>Energy industries</li>
        <li>Production and processing of metals</li>
        <li>Mineral industry</li>
        <li>Chemical industry</li>
        <li>Waste and wastewater</li>
        <li>Paper and wood industry</li>
        <li>Animal husbandry and fish farming</li>
        <li>Food and beverage industry</li>
        <li>Other</li>
      </ul>
      <p>
        Facilities are obligated to report emissions exceeding the capacity or
        emission specific thresholds. The emission values include possible
        emissions during exceptinal situations (e.g. disturbances in process or
        in abatement). Other activities e.g. small scale industries or diffuse
        emissions from transport or consumer products are not included in the
        register.{' '}
      </p>
      <p>
        Carbon dioxide emissions are presented as the sum of fossile and
        biological CO2 as well as fossile CO2. The search{' '}
        <i>Carbon dioxide (excl. biological)</i> returns fossile CO2, which is
        generated in combustion of fossile fuels. Biological carbon dioxide is
        generated in combustion of biomass and is not included in the reduction
        commitments under international conventions (e.g. climate convention).
      </p>
      <p>
        Facilities report annually information on releases to air and water
        regarding the 91 substances included in Annex 5 of the PRTR protocol,
        when the releases exceed the reporting thresholds, as well as
        information on waste transfers. Releases to soil are not included in the
        reporting (not allowed in Finland). Finnish facilities report waste
        transfers in line with the European waste catelogue. In other countries,
        alternatively chemicals included in waste may be reported, and, in
        addition to Annex 5, it is possible to nationally choose to report
        releases of other chemicals. The register includes 65 activities.{' '}
      </p>
      Sector specific BREF documents on best available techniques can be found
      at{' '}
      <a href="https://www.ymparisto.fi/fi-fi/kulutus_ja_tuotanto/paras_tekniikka_bat/vertailuasiakirjat">
        BAT documents
      </a>
      <p>
        Information on non-point sources, such as transport, agriculture and
        product use, is often included in release registers. Information on
        non-point source emissions to air can be found at{' '}
        <a href="https://www.environment.fi/en-US/Forms_permits_and_environmental_impact_assessment/Reporting/PRTR_Nonpoint_source_emissions">
          environment.fi
        </a>
        .
      </p>
       <h2>Short history of release and transfer registers</h2>
      <p>
        Public access to environmental information was included already in the
        1992 Rio Declaration. UNECE Convention on Access to Information, Public
        Participation in Decision-making and Access to Justice in Environmental
        Matters (Aarhus Convention) took effect in 1998. Environmental
        information shall be publicly accessible on request or through active
        dissemination, e.g. electronically, and in national languages.
        Information shall cover health or environmentally harmful releases that
        are restricted by legislation and that operators are requested to
        monitor. The Convention took effect in 2001 when 17, mainly Eastern
        European and Middle Eastern countries, had ratified it. Finland signed
        Aarhus Convention in 1998 and ratified it in 2004, when it also took
        effect in Finland - however, the Finnish legislation fulfilled the
        requirements also before that. EU signed the Convention in 1998 and
        ratified it in 2005. Currently there are appr. 50 countries that have
        ratified or signed the Convention{' '}
        <a
          href="https://treaties.un.org/Pages/ViewDetails.aspx?src=IND&mtdsg_no=XXVII-13&chapter=27&clang=_en#1"
          target="blank">
          ...
        </a>
        . 
      </p>
      <p>
        {' '}
        Kiev Protocol under the Aarhus Convention is the first legally binding
        international document on release and transfer registers (Pollutant
        Release and Transfer Register, PRTR) with the aim to increase access to
        environmental information, e.g. through consistent format in the
        national registers and it also provides the companies possibility to
        show that they operate in an environmentally  conscious manner as they
        monitor their releases. Finland signed Kiev Protocol in 2003 (the same
        year as the EU) and ratified it in 2009, the EU in 2006.  
      </p>
      <p>
        {' '}
        The European Pollutant Emission Register, EPER was established in 2000
        on the basis of the 1996 IPCC Directive  on  integrated pollution
        prevention and control. EPER was succeeded by the European Pollutant
        Release and Transfer Register, E-PRTR in 2006. Information on Finnish
        facilities has been reported to both registers from the beginning. Since
        2021 information on releases is available in{' '}
        <a href="https://industry.eea.europa.eu/" target="blank">
          Industrial Emissions Portal
        </a>{' '}
        maintained by the EEA.
      </p>
      <p>
        <a
          href="https://unece.org/DAM/env/pp/documents/cep43e.pdf"
          target="blank">
          Aarhus Convention
        </a>
        &nbsp;(pdf 50 kt)
      </p>
      <p>
        <a
          href="https://ec.europa.eu/environment/industry/stationary/e-prtr/pdf/en_prtr.pdf"
          target="blank">
          Commission Decision PRTR
        </a>
        &nbsp;(pdf 115 kt)
      </p>
      <h2>Permits</h2>
      <p>
        Activities causing environmental pollution require a permit in
        accordance with the Environmental Protection Act. One can search for the
        permits of the facilities presented in this service from the{' '}
        <a href="https://ytietopalvelu.lvv.fi/fi-FI" target="blank">
          Environmental information service of the Finnish Supervisory Agency
        </a>
        .
      </p>
      <h2>Best available technology</h2>
      <p>
        The emission limit values, monitoring and other permit regulations of
        plants covered by the Industrial Emissions Directive are based on the
        best available technology. It refers to production and purification
        methods that are as efficient and advanced as possible and technically
        and economically feasible, as well as methods for planning,
        constructing, maintaining, operating and terminating operations, which
        can prevent or most effectively reduce environmental pollution caused by
        the operations and which are suitable as the basis for environmental
        permit regulations. As a result of the exchange of information between
        industry and authorities organised by the European Commission, BAT
        reference documents and BAT conclusions binding on the Member States
        will be published. Reference documents and BAT conclusions can be found
        on the website of{' '}
        <a href="https://eippcb.jrc.ec.europa.eu/reference" target="blank">
          the European IPPC Office
        </a>
        .
      </p>
      <h2>Information of the service</h2>
      <p>
        Finnish Environment Institute has built the website on the request from
        the Ministry of the Environment. Feedback on data and other content can
        be sent to supervising authorities (
        <a href="https://lvv.fi/en/environment" target="blank">
          Finnish Supervisory Agency
        </a>
        ). Feedback on the technical functions or improvement proposals can be
        sent to <a href="mailto:PRTR@syke.fi">PRTR@syke.fi</a>.
      </p>
      <p>
        <a href="Käyttöehdot.pdf" target="blank">
          Terms of use
        </a>
      </p>
      <p>
        <a href="Palveluseloste.pdf" target="blank">
          Service proxy
        </a>
      </p>
    </>
  )
}
